import axios from '../axios';

export const fetchAllUsers = (payload) => axios.post('/users', payload);

export const updateUser = (id, payload) => axios.post(`/users/${id}`, payload);

export const fetchAllUsersById = (id) => axios.get(`/users/${id}`);

export const loginUser = (payload) => axios.post('/admin/login', payload);

export const deleteUser = (id) => axios.delete(`/users/${id}`);

export const refreshToken = (payload) => axios.post(`/admin/refresh-token`, payload);

export const addPlaylistsToUser = (id, payload) => axios.post(`/users/${id}/playlists/add`, payload);

